import React from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function FailurePage() {
  const navigate = useNavigate();
  const { job_id: jobId } = useParams();

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg px-4">
      <div className="p-10 max-w-5xl w-full rounded-lg shadow-sm bg-white border border-border text-center">

        <h2 className="text-4xl font-bold mb-6 text-red-500">Payment Failed!</h2>

        <p className="text-lg mb-6 text-text-secondary">
          Your payment for Job ID{" "}
          <span className="font-semibold text-text-primary">{jobId}</span> could not be
          processed.
        </p>

        <button
          className="bg-white hover:bg-red-50 border border-red-400 text-red-500 font-semibold px-6 py-3 rounded-md text-lg transition"
          onClick={() => navigate("/migrate")}
        >
          Try Again
        </button>
      </div>
    </div>
  );
}